const types = [
    'Audios',
    'Files',
    'Gif',
    'Images',
    'Videos'
];

export default {types}


// WEBPACK FOOTER //
// ./src/lib/FileTypes.js